
import service from '@/store/services/settings/skills-categories-service';

const state = {
    list: {},
    skillCategory: {},
    meta: {},
    skill: {},

};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, skillCategory) => {
        state.skillCategory = skillCategory;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(skillCategory => {
                commit('SET_RESOURCE', skillCategory);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(skillCategory => {
                commit('SET_RESOURCE', skillCategory);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((skillCategory) => {
                commit('SET_RESOURCE', skillCategory);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((skillCategory) => {
                commit('SET_RESOURCE', skillCategory);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    skills ({ commit, dispatch }, { category,params = {} }) {
        return service.skills(category,params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    skillCategory: state => state.skillCategory,
    skill: state=> state.skill,
    dropdown: (state) => {
        return state.list.map(skillCategory => ({
            id: skillCategory.id,
            name:skillCategory.name,
            alias:skillCategory.alias,
        }));
    }
};

const skillCategories = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default skillCategories;
